'use strict';
import get from 'lodash/get';
import map from 'lodash/map';
import noop from 'lodash/noop';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {stateGoBack} from '../../app/actions';
import {getAsset, getProject} from '../../app/model/reducers/state';
import {toStringStatic} from '../../assets/domain/AssetDomain';
import {IONIC_VIEW_ENTER, IONIC_VIEW_LEAVE, SCOPE_DESTROY} from '../../config/constants/view-events';
import {
  isWebView,
  supportsCamera,
  supportsDownload,
  supportsPickFile, supportsVideo,
} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {
  getAsString,
  getCollection,
  getDomainClass,
  getDomainLink,
  getId,
  getLink,
} from '../../core-utilities/domain/ReduxUtils';
import {errorHandler, eventToObservable} from '../../core-utilities/rx-utils';
import {
  assetRequirementListActions,
  projectRequirementListActions,
  templateRequirementListActions,
} from '../../requirements/actions';
import * as infoModalActions from '../../requirements/actions/infoModalActions';
import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from '../../requirements/domain/config';
import {calcUploadFileByStatus, checkCanAddFile} from '../../requirements/domain/files/utils';
import {reduxList as assetReqList} from '../../requirements/redux/assetReqList';
import {reduxList as projectReqList} from '../../requirements/redux/projectReqList';
import {reduxList as templateReqList} from '../../requirements/redux/templateReqList';
import {createAssetFileRequirementRequestModal} from '../../requirements/redux/files/createAssetFileRequirement';
import {createProjectFileRequirementRequestModal} from '../../requirements/redux/files/createProjectFileRequirement';
import {createTemplateFileRequirementRequestModal} from '../../requirements/redux/files/createTemplateFileRequirement';
import {createAssetFormRequirementRequestModal} from '../../requirements/redux/forms/createAssetFormRequirement';
import {createProjectFormRequirementRequestModal} from '../../requirements/redux/forms/createProjectFormRequirement';
import {createTemplateFormRequirementRequestModal} from '../../requirements/redux/forms/createTemplateFormRequirement';
import {getTaskListActions} from '../actions';
import {ASSET_TASK_COLLECTION} from '../domain/config';
import {TaskType} from '../enums/TaskType';
import {logger} from './logger';
import {isIosBuild} from "../../config/constants";


const angular = require('angular');
const {extend} = angular;

TasksDetailsController.$inject = [
  '$scope',
  '$miscUtils',
  '$ngRedux',
  '$contextMenu',
  '$permissions',
  'rxPermissionsService',
  '$popup',
  '$toast',
  '$filter',
  '$ionicViewSwitcher',
  'requirementCreateModals',
  'selectorsService',
  'FilePickerFactory',
  'PersistentUploaderService',
  'PersistentUploaderFactory',
  'DeviceServices',
  'FilesDownloadService',
  'FILE_USAGE',
  'childModelDeletedManager',
  'timerExportService',
  'TaskDomain',
  'AssetTaskDomain',
  'FileRequirementDomain',
  'OrganizationDomain',
  'parentStatusService',
  'task',
  'requirementType',
  'ctrlConfig',
  'TOAST_TYPES',
];

/* const VIEW_ACTIONS = {
 canAddReq: '(template_|asset_)task_requirements_create',
 canDownloadFiles: '(asset_)task_fulfillments_view',
 canEdit: '(template_|asset_)task_data_edit',
 canViewAccess: '(asset_)task_access_view',
 canEditSchedule: '(asset_)task_schedule_edit',
 canOverrideSchedule: '(asset_)task_schedule_override',
 canDelete: '(template_|asset_)task_data_delete',
 canApprove: '(asset_)task_status_approve'
 };*/

function get_VIEW_ACTIONS_PROJECT(roleData) {
  const isLocked = roleData.projectIsLocked || roleData.taskIsLocked;
  return {
    canAddReq: isLocked ? 'task_requirements_create_locked' : 'task_requirements_create',
    canDownloadFiles: 'task_fulfillments_view',
    canEdit: 'task_data_edit',
    canViewAccess: 'task_access_view',
    canEditSchedule: 'task_schedule_edit',
    canOverrideSchedule: 'task_schedule_override',
    canDelete: isLocked ? 'task_data_delete_locked' : 'task_data_delete',
    canApprove: 'task_status_approve',
  };
}

function get_VIEW_ACTIONS_TEMPLATE(roleData) {
  const isLocked = roleData.projectIsLocked || roleData.taskIsLocked;

  let canDelete = roleData.taskIsPrivate ? 'task_data_delete' : 'template_task_data_delete';
  if (isLocked)
    canDelete += '_locked';

  return {
    canAddReq: isLocked ? 'template_task_requirements_create_locked' : 'template_task_requirements_create',
    canDownloadFiles: 'task_fulfillments_view',
    canEdit: roleData.taskIsPrivate ? 'task_data_edit' : 'template_task_data_edit',
    canViewAccess: 'task_access_view',
    canDelete,
    canApprove: 'task_status_approve',
  };
}

function get_VIEW_ACTIONS_ASSET(roleData) {
  const isLocked = roleData.projectIsLocked || roleData.assetProjectIsLocked || roleData.assetTaskIsLocked;

  return {
    canAddReq: isLocked ? 'asset_task_requirements_create_locked' : 'asset_task_requirements_create',
    canDownloadFiles: 'asset_task_fulfillments_view',
    canEdit: 'asset_task_data_edit',
    canViewAccess: 'asset_task_access_view',
    canEditSchedule: 'asset_task_schedule_edit',
    canOverrideSchedule: 'asset_task_schedule_override',
    canDelete: isLocked ? 'asset_task_data_delete_locked' : 'asset_task_data_delete',
    canApprove: 'asset_task_status_approve',
  };
}

export function TasksDetailsController(
  $scope,
  $miscUtils,
  $ngRedux,
  $contextMenu,
  $permissions,
  rxPermissionsService,
  $popup,
  $toast,
  $filter,
  $ionicViewSwitcher,
  requirementCreateModals,
  selectorsService,
  FilePickerFactory,
  PersistentUploaderService,
  PersistentUploaderFactory,
  DeviceServices,
  FilesDownloadService,
  FILE_USAGE,
  childModelDeletedManager,
  timerExportService,
  TaskDomain,
  AssetTaskDomain,
  FileRequirementDomain,
  OrganizationDomain,
  parentStatusService,
  task,
  requirementType,
  ctrlConfig,
  TOAST_TYPES,
) {
  const vm = $scope.taskDetails = this;
  const scopeDestroy$ = eventToObservable($scope, SCOPE_DESTROY);
  const filePickers = {};
  const onFileSelectSuccessByRequirement = {};

  childModelDeletedManager.watchModel(task, goBack, $scope);

  function goBack() {
    $ngRedux.dispatch(stateGoBack({state: ctrlConfig.taskListState}));
  }

  const permissions$ = observePermissions();

  bindReactProps();
  fixReduxListInit();

  function bindReactProps() {
    const BASE_PROPS = {
      // View props
      onClickOptions: showMenu,
      onClickOptions_wrap: false,
      onAddFileRequirement: addFileRequirement,
      onAddFileRequirement_wrap: false,
      onAddFormRequirement: addFormRequirement,
      onAddFormRequirement_wrap: false,
      onDownloadAllFiles: downloadAllFiles,
      onDownloadAllFiles_wrap: false,
      onDeleteTask: deleteTask,
      onDeleteTask_wrap: false,

      // Item props
      onItemContextMenu: (e, model) => showRequirementMenu(model),
      onItemContextMenu_wrap: false,
      onCameraButtonClick: (e, model) => openCameraFor(model),
      onCameraButtonClick_wrap: false,
      onVideoButtonClick: (e, model) => openVideoCameraFor(model),
      onVideoButtonClick_wrap: false,
      onUploadButtonClick: (e, model) => uploadFileFor(model),
      onUploadButtonClick_wrap: false,
      onUpIOSButtonClick: (e, model) => uploadIOSFileFor(model),
      onUpIOSButtonClick_wrap: false,
      onFileSelect: ctrlConfig.taskType === TaskType.TEMPLATE
        ? onFileSelectWarning
        : (e, model, files) => onFileSelectSuccess(model, {files}, false),
      onFileSelect_wrap: false,
      onFileSelectDenied: (e, model) => onFileSelectDenied(model),
      onFileSelectDenied_wrap: false,
    };

    vm.viewProps = {
      ...BASE_PROPS,
      permissionsData: {permissions: {}, hasPermission: noop},
      canUploadFileByStatus: {},
    };

    const props$ = Observable
      .combineLatest(
        permissions$,
        (permissionsData) => ({
          viewProps: {
            ...BASE_PROPS,

            // Needs to come from the angular controller due to the way the current router library view caching works.
            parentId: getId(task),
            permissionsData,
            canAddReq: get(permissionsData.permissions, 'canAddReq', false),
            canDownloadFiles: get(permissionsData.permissions, 'canDownloadFiles', false),
            canEdit: get(permissionsData.permissions, 'canEdit', false),
            canDelete: get(permissionsData.permissions, 'canDelete', false),
            canUploadFileByStatus: calcUploadFileByStatus(permissionsData),
          },
        })
      )
      .takeUntil(scopeDestroy$);

    props$
      .throttleTime(500, void 0, {leading: true, trailing: true})
      .catch(errorHandler(logger, 'bindReactProps failed'))
      .subscribe(nextState => $scope.$safeApply(() => vm.viewProps = nextState.viewProps));
  }

  // HACK: Handle list initialization logic in the angular controller so that we can reliably control this from one place,
  // the currently active controller associated with the loaded view
  // This replaces performing this list update in an epic.
  // Since the router might cache this, we cannot intialize the list from the react component reliably.
  function fixReduxListInit() {
    const SKIP_UPDATE = {};
    const nextParentId = getId(task);
    const reduxList = getRequirementList();
    const reduxListActions = reduxList.actions;
    const stateAccessor = reduxList.options.getState;

    eventToObservable($scope, IONIC_VIEW_ENTER)
      .startWith(null)
      .map(() => {
        const listState = stateAccessor($ngRedux.getState());
        const prevParentId = listState.init ? listState.parentId : null;

        return prevParentId === nextParentId ? SKIP_UPDATE : prevParentId;
      })
      .filter(prevParentId => prevParentId !== SKIP_UPDATE)
      .switchMap(prevParentId => {
        if (prevParentId) {
          return Observable
            .merge(
              Observable.of(reduxListActions.destroyList({}, {parentId: prevParentId})),
              Observable
                .timer(33)
                .mapTo(reduxListActions.initList({parentId: nextParentId})),
            );

        } else {
          return Observable.of(reduxListActions.initList({parentId: nextParentId}));
        }
      })
      .takeUntil(scopeDestroy$)
      .subscribe(action => $ngRedux.dispatch(action));

    // Destroy the list here since we cannot do so reliably from the redux list
    scopeDestroy$
      .subscribe(() => {
        const listState = stateAccessor($ngRedux.getState());

        if (listState.init && listState.parentId === nextParentId) {
          const action = reduxListActions.destroyList({}, {parentId: nextParentId});
          $ngRedux.dispatch(action);
        }
      });
  }

  function getRequirementList() {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        return assetReqList;
      case TaskType.PROJECT:
        return projectReqList;
      case TaskType.TEMPLATE:
        return templateReqList;
    }
  }
  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  function generate_DELETE_TASK(task) {
    let permission;
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        permission = 'asset_task_data_delete';
        break;

      case TaskType.PROJECT:
        permission = 'task_data_delete';
        break;

      case TaskType.TEMPLATE:
        permission = !task.isPrivate ? 'template_task_data_delete' : 'task_data_delete';
        break;
    }

    if (parentStatusService.isParentTaskLocked(ctrlConfig.taskType, task))
      permission += '_locked';

    return {
      permission,
      action: {messageId: 'tasks.details.context.delete.label', action: deleteTask, important: true},
    };
  }

  function generate_OPEN_CAMERA(requirement) {
    return {
      action: {messageId: 'requirements.files.buttons.camera.label', action: openCameraFor.bind(null, requirement)},
    };
  }

  function generate_OPEN_VIDEO_CAM(requirement) {
    return {
      action: {messageId: 'requirements.files.buttons.video.label', action: openVideoCameraFor.bind(null, requirement)},
    };
  }

  function generate_UPLOAD_FILE(requirement) {
    return {
      action: {messageId: 'requirements.files.buttons.upload.label', action: uploadFileFor.bind(null, requirement)},
    };
  }

  function generate_UPLOAD_IOS_FILE(requirement) {
    return {
      action: {messageId: 'requirements.files.buttons.upload.label.ios', action: uploadIOSFileFor.bind(null, requirement)},
    };
  }

  function generate_SHOW_REEQ_INFO(requirement) {
    return {
      action: {messageId: 'tasks.details.context.show.info.label', action: showReqInfo.bind(null, requirement)},
    };
  }

  function generate_DOWNLOAD_ALL_REQ(requirement) {
    const permission = $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_fulfillments_view';

    return {
      permission,
      action: {
        messageId: 'requirements.context.download.files.label',
        action: downloadAllRequirementFiles.bind(null, requirement),
      },
    };
  }

  function generate_DELETE_REQ(requirement) {
    let permission = $permissions.permissionPrefix(ctrlConfig.taskType) + 'requirement_data_delete';
    if (parentStatusService.isParentReqLocked(ctrlConfig.taskType, task, requirement))
      permission += '_locked';

    return {
      permission,
      action: {
        messageId: 'requirements.context.delete.label',
        action: deleteRequirement.bind(null, requirement),
        important: true,
      },
    };
  }

  function getAddReqPermission() {
    let permission = $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_requirements_create';
    if (parentStatusService.isParentTaskLocked(ctrlConfig.taskType, task))
      permission += '_locked';

    return permission;
  }

  function generate_CREATE_FILE_REQUIREMENT() {
    return {
      permission: getAddReqPermission(),
      action: {messageId: 'tasks.details.context.addreq.file.label', action: addFileRequirement},
    };
  }

  function generate_CREATE_FORM_REQUIREMENT() {
    return {
      permission: getAddReqPermission(),
      action: {messageId: 'tasks.details.context.addreq.form.label', action: addFormRequirement},
    };
  }

  const DOWNLOAD_ALL_TASK = {
    permission: $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_fulfillments_view',
    action: {messageId: 'tasks.details.context.download.files.label', action: downloadAllFiles},
  };

  function showMenu() {
    const taskId = getId(task);
    const checkActions = [];

    if (ctrlConfig.taskType === TaskType.ASSET) {
      $contextMenu.addActionByAssetTask(checkActions, taskId, generate_CREATE_FILE_REQUIREMENT());
      $contextMenu.addActionByAssetTask(checkActions, taskId, generate_CREATE_FORM_REQUIREMENT());
      if (supportsDownload()) {
        $contextMenu.addActionByAssetTask(checkActions, taskId, DOWNLOAD_ALL_TASK);
      }
      timerExportService.buildContextAction(checkActions, exportTimerData);
      $contextMenu.addActionByAssetTask(checkActions, taskId, generate_DELETE_TASK(task));
    } else {
      $contextMenu.addActionByTask(checkActions, taskId, generate_CREATE_FILE_REQUIREMENT());
      $contextMenu.addActionByTask(checkActions, taskId, generate_CREATE_FORM_REQUIREMENT());
      if (supportsDownload()) {
        $contextMenu.addActionByTask(checkActions, taskId, DOWNLOAD_ALL_TASK);
      }
      timerExportService.buildContextAction(checkActions, exportTimerData);
      $contextMenu.addActionByTask(checkActions, taskId, generate_DELETE_TASK(task));
    }

    $contextMenu.showByPermission({
      titleMessageId: 'tasks.details.context.title.label',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function showRequirementMenu(requirement) {
    switch (getCollection(requirement)) {
      case ASSET_FILE_REQUIREMENT_COLLECTION:
      case FILE_REQUIREMENT_COLLECTION:
        showFileRequirementMenu(requirement);
        break;

      case ASSET_FORM_REQUIREMENT_COLLECTION:
      case FORM_REQUIREMENT_COLLECTION:
        showFormRequirementMenu(requirement);
        break;
    }
  }

  function showFileRequirementMenu(requirement) {
    const taskType = ctrlConfig.taskType;
    const isTemplate = taskType === TaskType.TEMPLATE;
    const showCameraButton = !isTemplate && supportsCamera();
    const showVideoButton = !isTemplate && supportsVideo();
    const showUploadButton = !isTemplate && supportsPickFile();
    const showIOSUpButton = !isTemplate && supportsPickFile() && isWebView();
    const taskId = getId(task);
    const checkActions = [];
    $contextMenu.addAction(checkActions, generate_SHOW_REEQ_INFO(requirement));

    const addAction = taskType === TaskType.ASSET
      ? $contextMenu.addActionByAssetTask
      : $contextMenu.addActionByTask;

    const status = requirement && requirement.status;
    const {
      hasPermission,
      roleData,
    } = vm.viewProps.permissionsData;

    if (checkCanAddFile(hasPermission, roleData, status, taskType)) {
      if (showCameraButton) {
        $contextMenu.addAction(checkActions, generate_OPEN_CAMERA(requirement));
      }
      if (showVideoButton) {
        $contextMenu.addAction(checkActions, generate_OPEN_VIDEO_CAM(requirement));
      }
      if (showUploadButton) {
        $contextMenu.addAction(checkActions, generate_UPLOAD_FILE(requirement));
      }
      if (showIOSUpButton) {
        $contextMenu.addAction(checkActions, generate_UPLOAD_IOS_FILE(requirement));
      }
    }

    if (!isTemplate && supportsDownload()) {
      addAction(checkActions, taskId, generate_DOWNLOAD_ALL_REQ(requirement));
    }

    addAction(checkActions, taskId, generate_DELETE_REQ(requirement));

    $contextMenu.showByPermission({
      titleMessageId: 'requirements.context.title.label',
      titleMessageParams: {requirementName: getAsString(requirement)},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  // TODO: add export actions
  function showFormRequirementMenu(requirement) {
    const taskId = getId(task);
    const checkActions = [];

    if (ctrlConfig.taskType === TaskType.ASSET) {
      // if (supportsDownload()) {
      //   $contextMenu.addActionByAssetTask(checkActions, taskId, generate_DOWNLOAD_ALL_REQ(requirement));
      // }
      $contextMenu.addActionByAssetTask(checkActions, taskId, generate_DELETE_REQ(requirement));
    } else {
      // if (supportsDownload()) {
      //   $contextMenu.addActionByTask(checkActions, taskId, generate_DOWNLOAD_ALL_REQ(requirement));
      // }
      $contextMenu.addActionByTask(checkActions, taskId, generate_DELETE_REQ(requirement));
    }

    $contextMenu.showByPermission({
      titleMessageId: 'requirements.context.title.label',
      titleMessageParams: {requirementName: getAsString(requirement)},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  // function addFileRequirement() {
  //   return requirementCreateModals.openCreateFileRequirement(null, task, ctrlConfig)
  //     .then(function (req) {
  //       if (req) {
  //         // filterService.loadOne(req, 'filteredFilesList');
  //       }
  //       return req;
  //     });
  // }

  function addFileRequirement() {
    const requestModal = getFileRequirementModal();
    // HACK: initial model until FormHOC is updated to support initialization/defaults
    const model = {
      minimumFileCount: 0,
      maximumFileCount: 1,
      countIsEnforced: false,
    };
    addRequirement(requestModal, model);
  }

  function addFormRequirement() {
    const requestModal = getFormRequirementModal();
    addRequirement(requestModal, null);
  }

  function addRequirement(requestModal, model) {
    if (!task) {
      return;
    }

    const rootState = $ngRedux.getState();
    const taskCollection = getCollection(task);
    const taskId = taskCollection === ASSET_TASK_COLLECTION ? getDomainLink(task, 'task').id : getId(task);
    const projectId = getId(getProject(rootState));

    if (!projectId) {
      return;

    } else if (ctrlConfig.taskType === TaskType.ASSET) {
      $ngRedux.dispatch(requestModal.actions.showModal({
        projectId,
        taskId,
        assetTaskId: getId(task),
        model,
      }));

    } else {
      $ngRedux.dispatch(requestModal.actions.showModal({
        projectId,
        taskId,
        model,
      }));
    }
  }

  function getFormRequirementModal() {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        return createAssetFormRequirementRequestModal;
      case TaskType.PROJECT:
        return createProjectFormRequirementRequestModal;
      case TaskType.TEMPLATE:
        return createTemplateFormRequirementRequestModal;
    }
  }

  function getFileRequirementModal() {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        return createAssetFileRequirementRequestModal;
      case TaskType.PROJECT:
        return createProjectFileRequirementRequestModal;
      case TaskType.TEMPLATE:
        return createTemplateFileRequirementRequestModal;
    }
  }

  function downloadAllFiles() {
    if (!task) return;
    FilesDownloadService.downloadTaskFiles(getId(task), task.name, ctrlConfig.taskType);
  }

  function exportTimerData() {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        timerExportService.exportAssetTask(task);
        break;

      case TaskType.PROJECT:
      case TaskType.TEMPLATE:
        timerExportService.exportTask(task);
    }
  }

  function showReqInfo(requirement) {
    $ngRedux.dispatch(infoModalActions.showModal(requirement));
  }

  function downloadAllRequirementFiles(requirement) {
    if (!requirement) return;
    FilesDownloadService.downloadRequirementFiles(getId(requirement), requirement.name, ctrlConfig.taskType);
  }

  let deleteTaskCalled = false;

  // TODO(redux): Convert to redux request
  function deleteTask() {
    if (deleteTaskCalled || !task) return;
    deleteTaskCalled = true;
    const id = getId(task);
    const label = getAsString(task);

    // TODO(i18n): translate task delete confirmation
    return $popup
      .confirm({
        title: 'Delete Task',
        template: 'Are you sure you want to delete ' + label,
      })
      .then(result => !result
        ? void 0
        : task.$delete().then(() => goBack(), err => dispatchDeleteTaskErrorAction({id, label, err}))
      )
      .finally(__deleteTaskFinally);
  }

  function __deleteTaskFinally() {
    deleteTaskCalled = false;
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  // function goToFileUpdate(requirement) {
  //   if (ctrlConfig.taskType === TaskType.TEMPLATE) {
  //     return FileRequirementDomain
  //       .$get(getId(requirement))
  //       .then(instance => requirementCreateModals.openCreateFileRequirement(instance, task, ctrlConfig));
  //   } else {
  //     $ionicViewSwitcher.nextDirection('forward');
  //     $ngRedux.dispatch(stateGo(ctrlConfig.fileUploadState, {requirementId: getId(requirement)}));
  //   }
  // }

  function deleteRequirement(requirement) {
    if (requirement) {
      const reqId = getId(requirement);
      const collection = getCollection(requirement);
      const label = getAsString(requirement);
      const deleteItem = getDeleteRequirementAction();
      // TODO(i18n): translate task delete confirmation
      return $popup
        .confirm({
          title: 'Delete Requirement',
          template: `Are you sure you want to delete ${label}`,
        })
        .then(result => !result ? void 0 : $ngRedux.dispatch(deleteItem({id: reqId, collection, label})));
    }
  }

  /**
   * @return {Function|ReduxActionCreator}
   */
  function getDeleteRequirementAction() {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        return assetRequirementListActions.deleteItem;
      case TaskType.PROJECT:
        return projectRequirementListActions.deleteItem;
      case TaskType.TEMPLATE:
        return templateRequirementListActions.deleteItem;
    }
  }

  function dispatchDeleteTaskErrorAction(payload) {
    $ngRedux.dispatch(getTaskListActions(ctrlConfig.taskType).deleteItemError(payload));
  }

  /*****************************************************************************************************************
   * Uploading Configuration
   ****************************************************************************************************************/

  function uploadFileFor(requirement) {
    // console.log('uploadFileFor', requirement);
    const domainClass = getDomainClass(requirement);
    _getFilePicker(requirement, false).pickFile(true, true, {
      filename: getAsString(requirement),
      getPath: getNewFulfillmentPath,
      usage: FILE_USAGE.GALLERY,
      attachable: {
        id: getId(requirement),
        collection: getCollection(requirement),
      },
      onSuccess: 'get("$domain").getDomain(collection).$addFileDomain(id, fileDomain)',
      onSuccessLocals: {
        id: getId(requirement),
        collection: getCollection(requirement),
      },
    });

    function getNewFulfillmentPath() {
      const options = domainClass.$generateFileRequest(requirement);

      return {
        path: options.path,
        firebasePath: options.firebasePath,
      };
    }
  }

  function uploadIOSFileFor(requirement) {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    const project = getProject(rootState);
    const dirName = (ctrlConfig.taskType === TaskType.ASSET
      ? getAsString(asset, toStringStatic)
      : getAsString(project))
      || 'tmp';
    _getFilePicker(requirement, false).uploadMobileIOSFile(dirName, getAsString(requirement));
  }

  function openCameraFor(requirement) {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    const project = getProject(rootState);
    const dirName = (ctrlConfig.taskType === TaskType.ASSET
      ? getAsString(asset, toStringStatic)
      : getAsString(project))
      || 'tmp';
    _getFilePicker(requirement, true).openCamera(dirName, getAsString(requirement));
  }

  function openVideoCameraFor(requirement) {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    const project = getProject(rootState);
    const dirName = (ctrlConfig.taskType === TaskType.ASSET
      ? getAsString(asset, toStringStatic)
      : getAsString(project))
      || 'tmp';
    _getFilePicker(requirement, false).openVideo(dirName, getAsString(requirement));
  }

  function _getFilePicker(requirement, fromCamera) {
    const reqId = getId(requirement);
    if (parentStatusService.isParentTaskLocked(ctrlConfig.taskType, task))  {
      return $toast.showI18nMessage({
        messageId: 'tasks.files.upload.denied.status.message',
        type: $toast.TOAST_TYPES.error,
      });
    } if (requirement.status === 'approved' || requirement.status === 'cancelled') {
      return $toast.showI18nMessage({
        messageId: 'requirements.files.upload.denied.message',
        type: $toast.TOAST_TYPES.error,
      });
    }

    return filePickers[reqId] || (filePickers[reqId] =
      filePickers[reqId] = FilePickerFactory($scope, {
        onSuccess: DeviceServices.isWebView() ? createOnFileSelectSuccess(requirement) : onFileSelect,
        onError: _onError,
      }));


    function onFileSelect(files) {
      // console.log('TaskDetails.onFileSelect', files);
      if (!(files && files.length)) return;

      createOnFileSelectSuccess(requirement)({
        files: files,
      }, fromCamera);
    }
  }

  function onFileSelectWarning() {
    $toast.showI18nMessage({
      messageId: 'tasks.template.upload.error.message',
      type: TOAST_TYPES.warning,
    });
    return noop;
  }

  function createOnFileSelectSuccess(requirement) {
    const reqId = getId(requirement);
    return onFileSelectSuccessByRequirement[reqId] ||
      (onFileSelectSuccessByRequirement[reqId] = _createSuccessClosure(requirement));
  }

  function _createSuccessClosure(requirement) {
    return function (fileData, fromCamera) {
      return onFileSelectSuccess(requirement, fileData, fromCamera);
    };
  }

  function onFileSelectSuccess(requirement, fileData, fromCamera) {
    const domainClass = getDomainClass(requirement);
    const locals = {
      id: getId(requirement),
      collection: getCollection(requirement),
    };

    if (fileData.file) {
      const options = domainClass.$generateFileRequest(requirement);
      options.modelId = getId(requirement);
      options.fileUri = fileData.uri;
      options.filename = getAsString(requirement);
      options.usage = FILE_USAGE.GALLERY;
      options.onSuccess = 'get("$domain").getDomain(collection).$addFileDomain(id, fileDomain)';
      options.onSuccessLocals = locals;

      if (fromCamera) {
        PersistentUploaderFactory.generateExifData().then(exif => {
          const key = PersistentUploaderService.addFile(fileData.file, extend(options, exif));

          return PersistentUploaderService.upload(key).then(noop, _onError);
        });
      } else {
        const key = PersistentUploaderService.addFile(fileData.file, options);

        return PersistentUploaderService.upload(key).then(noop, _onError);
      }

    } else if (fileData.files && fileData.files.length) {
      const promises = map(fileData.files, function withFiles(file) {
        const options = domainClass.$generateFileRequest(requirement);
        options.modelId = getId(requirement);
        options.fileUri = fileData.uri;
        options.filename = getAsString(requirement);
        options.usage = FILE_USAGE.GALLERY;
        options.onSuccess = 'get("$domain").getDomain(collection).$addFileDomain(id, fileDomain)';
        options.onSuccessLocals = locals;

        const key = PersistentUploaderService.addFile(file, options);
        return PersistentUploaderService.upload(key);
      });

      return Promise.all(promises).then(noop, _onError);
    } else {
      console.warn('Must provide a file or FileList to upload');
      return Promise.reject('Must provide a file or FileList to upload');
    }
  }

  function onFileSelectDenied(requirement) {
    return $toast.showI18nMessage({
      messageId: 'requirements.files.upload.denied.message',
      messageParams: {name: getAsString(requirement)},
      type: $toast.TOAST_TYPES.error,
    });
  }

  function _onError(err) {
    logger({err});
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function observePermissions() {
    if (ctrlConfig.taskType === TaskType.ASSET) {
      const parentTaskId = getLink(task, 'task').id;
      const parentTask$ = parentTaskId ? Observable.fromPromise(getDomainLink(task, 'task')) : null;
      return rxPermissionsService.buildUserAssetTaskRoleData$(task.$observe(), parentTask$)
        .map(rxPermissionsService.assetTaskStateFn(getVIEW_ACTIONS))
        .startWith({permissions: {}, hasPermission: noop})
        .share();
    } else {
      return rxPermissionsService.buildUserTaskRoleData$(task.$observe())
        .map(rxPermissionsService.taskStateFn(getVIEW_ACTIONS))
        .startWith({permissions: {}, hasPermission: noop})
        .share();
    }
  }

  /**
   * @param {RoleData} roleData
   * @return {Object}
   */
  function getVIEW_ACTIONS(roleData) {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        return get_VIEW_ACTIONS_ASSET(roleData);

      case TaskType.PROJECT:
        return get_VIEW_ACTIONS_PROJECT(roleData);

      case TaskType.TEMPLATE:
        return get_VIEW_ACTIONS_TEMPLATE(roleData);
    }
  }

  return vm;
}



// WEBPACK FOOTER //
// ./src/js/tasks/controllers/TasksDetailsController.js